import React from 'react';
import {connect} from 'react-redux';
import {userActions} from '../../../services/actions';
import "./Login.css";
import {passwordNotValid} from "../../../services/auth-service/PasswordValidator";
import Disclaimer from "../../../layout/Disclaimer";
import PasswordInput from "../../../components/text-input/PasswordInput";

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.props.dispatch(userActions.logout());

        this.state = {
            username: '',
            password: '',
            submitted: false,
            mfaRequired: false,
            mfaToken: '',
            resendCountdown: 0,
            resendError: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMfaSubmit = this.handleMfaSubmit.bind(this);
        this.handleResendToken = this.handleResendToken.bind(this);
        this.countdownTimer = null;
    }

    componentWillUnmount() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }
    }

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({submitted: true});
        const {username, password} = this.state;

        if (passwordNotValid(password, true)) return;

        const {dispatch} = this.props;
        if (username && password) {
            dispatch(userActions.login(username.trim(), password, () => {
                this.setState({
                    mfaRequired: true,
                    resendCountdown: 60
                });
                this.startCountdown();
            }));
        }
    }

    startCountdown() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }
        this.countdownTimer = setInterval(() => {
            this.setState(prevState => {
                const newCountdown = prevState.resendCountdown - 1;
                if (newCountdown <= 0) {
                    clearInterval(this.countdownTimer);
                    return { resendCountdown: 0 };
                }
                return { resendCountdown: newCountdown };
            });
        }, 1000);
    }

    handleResendToken() {
        const { username, password } = this.state;
        const { dispatch } = this.props;

        this.setState({ resendError: null });

        dispatch(userActions.login(username.trim(), password, () => {
            this.setState({ resendCountdown: 60 });
            this.startCountdown();
        }));
    }

    handleMfaSubmit(e) {
        e.preventDefault();
        const {username, password, mfaToken} = this.state;
        const {dispatch} = this.props;

        if (mfaToken?.length === 6) {
            dispatch(userActions.login(username.trim(), password, null, mfaToken));
        }
    }

    render() {
        const {username, password, submitted, mfaRequired, mfaToken, resendCountdown, resendError} = this.state;

        if (mfaRequired) {
            // MFA verification form
            return (
                <div className="login-page">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 col-xl-4 mx-auto col-12">
                                <div className="login-form">
                                    <h4 className="mb-3">Multi-Factor Authentication</h4>
                                    <p className="text-muted mb-4">
                                        We've sent a 6-digit verification code to your email.
                                        Please enter it below to complete your login.
                                    </p>
                                    <form name="mfaForm" onSubmit={this.handleMfaSubmit}>
                                        <div className={'form-group' + (submitted && !mfaToken ? ' has-error' : '')}>
                                            <label htmlFor="mfaToken">Verification Code</label>
                                            <input
                                                type="text"
                                                className="form-control text-center"
                                                name="mfaToken"
                                                value={mfaToken}
                                                onChange={this.handleChange}
                                                maxLength="6"
                                                placeholder="000000"
                                                autoFocus
                                                style={{fontSize: '1.5rem', letterSpacing: '0.5rem'}}
                                            />
                                            {submitted && !mfaToken &&
                                                <div className="help-block">Verification code is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <small className="text-muted">
                                                The code will expire in 10 minutes
                                            </small>
                                        </div>
                                        {resendError && (
                                            <div className="alert alert-warning" role="alert">
                                                {resendError}
                                            </div>
                                        )}
                                        <div className="form-group mt-4">
                                            <button className="btn btn-success btn-block">Verify</button>
                                        </div>
                                        <div className="form-group text-center">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                onClick={this.handleResendToken}
                                                disabled={resendCountdown > 0}
                                            >
                                                {resendCountdown > 0
                                                    ? `Send Again (${resendCountdown}s)`
                                                    : 'Send Again'}
                                            </button>
                                        </div>
                                        <div className="form-group text-center">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                onClick={() => this.setState({mfaRequired: false, mfaToken: ''})}
                                            >
                                                Back to login
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Disclaimer/>
                </div>
            );
        }

        // Regular login form
        return (
            <div className="login-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mx-auto col-12">
                            <div className="login-form">
                                <form name="form" onSubmit={this.handleSubmit}>
                                    <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                                        <label htmlFor="username">E-mail</label>
                                        <input type="text" className="form-control" name="username"
                                               value={username} onChange={this.handleChange}/>
                                        {submitted && !username &&
                                            <div className="help-block">Username is required</div>
                                        }
                                    </div>
                                    <div className={'mb-0 form-group' + (submitted && !password ? ' has-error' : '')}>
                                        <label htmlFor="password">Password</label>
                                        <PasswordInput className="form-control" name="password"
                                                       value={password} onChange={this.handleChange}/>
                                        {submitted && !password &&
                                            <div className="help-block">Password is required</div>
                                        }
                                    </div>
                                    <div className="form-group">
                                        <a href="/forgotPassword">Forgot password?</a>
                                    </div>
                                    <div className="form-group mt-4">
                                        <button className="btn btn-success btn-block">Login</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Disclaimer/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);

export {connectedLoginPage as LoginPage};
